import Backbone from 'backbone';
import CoreLoginView from '../../../../core/views/Login';
import { redirectTo } from '../../utils';

class LoginView extends CoreLoginView {
	loginSuccess() {
		// redirectTo('game-selector');
		redirectTo();
		return Backbone.history.loadUrl();
	}
}

export default LoginView;